module.exports = __webpack_public_path__ + "static/media/izmerenie_ur.fcc092c9.pdf";